var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "camera__output" }, [
    _c("video", {
      ref: "videoContainer",
      staticClass: "camera-view",
      attrs: { autoplay: "", playsinline: "" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }